import React from "react";
import {
  Collapse,
  ControlGroup,
  Tag,
  EditableText,
  Card,
  Elevation,
} from "@blueprintjs/core";
import AsyncSelWrap from "../../utils/AsyncSelWrap";
import Diagnosis from "./Diagnosis";
import { apiCallPost } from "../../fns/util";
import cogoToast from "cogo-toast";
import { inject, observer } from "mobx-react";
import SuggColl from "../SuggColl";

class Analysis extends React.Component {
  state = {
    collapse: true,
    notesText: null,
    notesTouched: false,
    searching: false,
    searchResults: [],
  };
  renderNotes = () => {
    return (
      <div
        style={{ textAlign: "left", marginTop: "10px", marginBottom: "10px" }}
      >
        <EditableText
          multiline
          placeholder="You can use this space to keep your notes about the progression of the disease, or anything worth mentioning that you have noticed."
          value={
            this.state.notesTouched
              ? this.state.notesText
              : this.props.dxNotes[0].text
          }
          onChange={(event) =>
            this.setState({ notesText: event, notesTouched: true })
          }
          onConfirm={() =>
            this.props.update(
              "dxNotes",
              this.props.dxNotes[0]._id,
              "text",
              this.state.notesTouched
                ? this.state.notesText
                : this.props.dxNotes[0].text
            )
          }
        />
      </div>
    );
  };
  renderShort = () => {
    if (!this.props.data || !this.props.data.length) {
      return (
        <Tag minimal large>
          No diagnosis added.
        </Tag>
      );
    }
    let dxs = this.props.data.map((each) => each.disease);
    let txt = dxs.join(", ");
    return (
      <Tag minimal large multiline>
        {txt}
      </Tag>
    );
  };
  search = async (string) => {
    if (!string) {
      this.setState({ searchResults: [] });
      return;
    }
    try {
      this.setState({ searching: true });
      let res = await apiCallPost(
        `/clinical/${this.props.authStore.prefix}/unisearch`,
        { prefix: "dx", query: string }
      );
      this.setState({ searchResults: res, searching: false });
    } catch (err) {
      cogoToast.error(
        "There was an error in searching. Please check the console for more details.",
        { position: "bottom-left" }
      );
      console.log(err);
    }
  };
  renderHeading = () => {
    return (
      <ControlGroup>
        <Tag
          large
          intent="primary"
          interactive
          onClick={() => this.setState({ collapse: !this.state.collapse })}
        >
          Analysis
        </Tag>
        {!this.state.collapse ? (
          this.renderShort()
        ) : (
          <AsyncSelWrap
            placeholder="Diseases..."
            searching={this.state.searching}
            items={this.state.searchResults}
            selectedItem={null}
            update={(item) => this.search(item)}
            onChange={(item) => {
              let dd = item.data;
              dd["_id_sr"] = item._id;
              dd["type"] = "new";
              dd["checked"] = false;
              dd["query"] = false;
              dd["site"] = "Both Eyes";
              dd["anatomy"] = item.helper;
              this.props.add("eyeDx", dd);
            }}
          />
        )}{" "}
      </ControlGroup>
    );
  };
  renderDiagnosis = () => {
    if (!this.props.data || !this.props.data.length) {
      return (
        <ControlGroup style={{ marginTop: "10px" }}>
          <Tag minimal large>
            No diagnosis added.
          </Tag>
        </ControlGroup>
      );
    }
    return this.props.data.map((each) => {
      return (
        <Diagnosis
          data={each}
          update={(dxId, key, value) =>
            this.props.update("eyeDx", dxId, key, value)
          }
          remove={(dxId) => this.props.remove(dxId)}
        />
      );
    });
  };
  render() {
    return (
      <Card
        style={{ padding: "0px", background: "none" }}
        elevation={Elevation.FOUR}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignContent: "start",
            justifyContent: "left",
            padding: "10px",
          }}
        >
          {this.renderHeading()}
          <Collapse isOpen={this.state.collapse}>
            <SuggColl
              ana_prefix=""
              prefix="dx"
              visitId={this.props.visitId}
              addObjectInside={this.props.addObjectInside}
            />
            {this.renderDiagnosis()}
            {this.renderNotes()}
          </Collapse>
        </div>
      </Card>
    );
  }
}

export default inject(
  "bookingStore",
  "authStore",
  "billingStore",
  "patientStore",
  "listStore"
)(observer(Analysis));
